export function hasStoreBankDetails(store = {}) {
  if (store.hasPaymentDetails === true) return true;
  const pd = store.paymentDetails || {};
  return Boolean(
    String(pd.bankName || store.bankName || '').trim() &&
    String(pd.accountNumber || store.bankAccount || '').trim() &&
    String(pd.accountHolder || store.accountHolder || '').trim()
  );
}

export function canPublishStore(store = {}, hasActivePackage) {
  return !!hasActivePackage && hasStoreBankDetails(store) && store.adminDeleted !== true && store.adminDisabled !== true;
}

export function storePublicationStatus(store) {
  if (!store) return { live: false, label: 'Not published yet', message: 'Complete and save your shop settings to publish your shop.' };
  if (store.adminDeleted) return { live: false, label: 'Deleted by admin', message: 'This shop is hidden. Ask an administrator to use Restore in Shop Registration. Saving details or approving KYC will not restore it.' };
  if (store.adminDisabled) return { live: false, label: 'Disabled by admin', message: 'This shop is hidden. Ask an administrator to enable it in Shop Registration.' };

  if (!hasStoreBankDetails(store)) {
    return {
      live: false,
      label: 'Bank details pending',
      message: 'Add and save your bank details in Payment Details before your shop can accept customer orders.',
    };
  }

  const expiry = store.storePackageExpiresAt;
  const expiryMs = expiry?.toMillis?.() ?? (expiry?.seconds ? expiry.seconds * 1000 : expiry ? new Date(expiry).getTime() : 0);
  if (store.hasStorePackage === false || store.storePackageStatus === 'expired' || (expiryMs && expiryMs < Date.now())) return { live: false, label: 'Package inactive', message: 'Activate or renew your store package to make your shop available.' };
  if (store.published !== true) return { live: false, label: 'Not published yet', message: 'Save your shop settings with an active package to publish your shop.' };
  return { live: true, label: 'Published', message: 'Your shop is available through its public link.' };
}
